import React from 'react'
import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NewBadge } from '@retailer-platform/dashboard/gin-and-tonic'
import { roleManagementRouter } from './routing/roleManagementRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'role-management',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'role-management-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
  },
  routers: {
    scoped: [roleManagementRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
}

export default definition
